import { useEffect } from 'react';
import { isObject } from 'ramda-extension';
import { useDispatch } from 'react-redux';

import useFormData from '@gef-ui/form-core/hooks/state/useFormData';

import producedProduction from 'features/views/production/common';

import FormNew from './FormNew';

export const Filter = () => {
	const dispatch = useDispatch();

	const formData = useFormData();
	const formIsInitiated = isObject(formData);

	// Set organization structure of form and load documents by that structure
	useEffect(() => {
		if (formIsInitiated) {
			dispatch(producedProduction.actions.startupProducedProduction());
		}
	}, [dispatch, formIsInitiated]);

	return <FormNew />;
};

export default Filter;
